import lpImg from '../../../assets/images/lp.jpg';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';

const LpSecoundary = () => {
  const issues: String[] = [
    'デザインはよくわからない',
    'HTMLやCSSもよくわからない',
    '制作費を抑えたい',
    'もっと安く作りたい',
    'でもクオリティに妥協はしたくない',
  ];
  return (
    <section className="lpSecondary section">
      <div className="lpSecondary_l">
        <h2 className="lpSecondary_l_title">LPを制作します</h2>
        <ul className="lpSecondary_l_ul">
          {issues.map((value, index) => {
            return (
              <li
                className="lpSecondary_l_ul_li flex flex-center flex-wrap"
                key={index.toString()}
              >
                <ArrowRightIcon />
                {value}
              </li>
            );
          })}
        </ul>
      </div>
      <div className="lpSecondary_r">
        <img src={lpImg} alt="" className="lpSecondary_r_img lpShadow" />
      </div>
    </section>
  );
};

export default LpSecoundary;
